import httpClient from '../http/http-client';
import {
  IAiCopilotResponse,
  IExplainEmissionRequest,
  IReportMovementRequest,
  IDraftReportSectionRequest,
  IDraftSecrSectionRequest,
  IDataQualitySuggestionsRequest,
  IAskReportQuestionRequest,
} from './ai-copilot.model';

export default class AiCopilotService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async explainEmission(payload: IExplainEmissionRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/explain-emission', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async explainReportMovement(payload: IReportMovementRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/explain-report-movement', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async draftReportSection(payload: IDraftReportSectionRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/draft-report-section', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async draftSecrSection(payload: IDraftSecrSectionRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/draft-secr-section', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async dataQualitySuggestions(payload: IDataQualitySuggestionsRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/data-quality-suggestions', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async askReportQuestion(payload: IAskReportQuestionRequest): Promise<IAiCopilotResponse> {
    return this.http.post('ai/copilot/ask-report-question', payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
